import React from 'react';

import { Autocomplete, Checkbox, TableCell, TableRow, TextField } from '@mui/material';

import { egsRoomName } from '../tabs/egs/egsModel';
import { EGS_GUEST_TYPE_LABELS } from '../tabs/egs/fields';
import type { EgsRoomRow } from '../tabs/egs/previousEgs';
import type { RoomAssetLink } from '../tabs/packageOptions/types';

export type EgsRoomsChange = (key: string, rooms: Array<string>) => void;

export type EgsSkipChange = (key: string, skipped: boolean) => void;

type CopyEgsRoomsRowProps = {
  allRooms: Array<RoomAssetLink>;
  onRoomsChange: EgsRoomsChange;
  onSkipChange: EgsSkipChange;
  row: EgsRoomRow;
  rooms: Array<string>;
  skipped: boolean;
};

export default function CopyEgsRoomsRow({
  allRooms,
  onRoomsChange,
  onSkipChange,
  row,
  rooms,
  skipped,
}: CopyEgsRoomsRowProps) {
  const missingRooms = !skipped && !rooms.length;

  function handleChange(_event: React.SyntheticEvent, value: Array<string>) {
    onRoomsChange(row.key, value);
  }

  function handleSkipChange(event: React.ChangeEvent<HTMLInputElement>) {
    onSkipChange(row.key, event.target.checked);
  }

  return (
    <TableRow>
      <TableCell>{row.name || 'No name'}</TableCell>
      <TableCell>{row.guestTypes.map((guestType) => EGS_GUEST_TYPE_LABELS[guestType]).join(', ')}</TableCell>
      <TableCell sx={{ minWidth: 280 }}>
        <Autocomplete
          disableCloseOnSelect
          disabled={skipped}
          multiple
          onChange={handleChange}
          getOptionKey={(roomId) => roomId}
          getOptionLabel={(roomId) => egsRoomName(allRooms, roomId)}
          options={allRooms.map((room) => room.id)}
          renderInput={(params) => (
            <TextField
              {...params}
              error={missingRooms}
              helperText={missingRooms ? 'Pick at least one room' : undefined}
              placeholder={rooms.length ? undefined : 'Pick rooms'}
            />
          )}
          size="small"
          value={rooms}
        />
      </TableCell>
      <TableCell padding="checkbox">
        <Checkbox
          checked={skipped}
          inputProps={{ 'aria-label': `Skip ${row.name}` }}
          onChange={handleSkipChange}
          size="small"
        />
      </TableCell>
    </TableRow>
  );
}
